<section *ngIf="data.visible !== false">
  <mat-form-field class="mat-text" appearance="fill" subscriptSizing="dynamic">
    <mat-label>{{ data.label }}</mat-label>
    <input
      matInput
      type="text"
      [value]="inputValue"
      (input)="onDataChange($event)"
      [attr.aria-invalid]="!!errorMessage"
      [attr.required]="data.mandatory ? true : null"
    />
  </mat-form-field>
  <mat-error class="mat-error" *ngIf="errorMessage">{{
    errorMessage
  }}</mat-error>
</section>
